import { checkMessageEn, validateSpaceTextInput } from '@Utils/validation';
import {
  IEsgGreenhousePrincipleFormValues,
  IGreenhouseStandardFormValues,
} from '../EsgGreenhouseFormProvider/types';
import { GREENHOUSE_STANDARD_LIST_ID } from './GreenhouseStandardList';

export const checkPrincipleCompletionTh = (
  principles: Record<string, IEsgGreenhousePrincipleFormValues>,
  remark?: IGreenhouseStandardFormValues['remark']
) => {
  let isOtherCompleted = true;
  const selectedPrinciples = Object.keys(principles).filter((principle) => {
    const { checked } = principles[principle];
    return checked;
  });

  if (!validateSpaceTextInput(remark?.descriptionTh)) {
    return false;
  }

  selectedPrinciples.map((principle) => {
    const { infoCategoryMasterDataId, nameTh } = principles[principle];
    if (infoCategoryMasterDataId === GREENHOUSE_STANDARD_LIST_ID.OTHER) {
      if (nameTh && nameTh.trim() !== '') {
        isOtherCompleted = true;
      } else {
        isOtherCompleted = false;
      }
    }
  });

  return selectedPrinciples.length > 0 && isOtherCompleted;
};

export const checkPrincipleCompletionEn = (
  principles: Record<string, IEsgGreenhousePrincipleFormValues>,
  remark?: IGreenhouseStandardFormValues['remark']
) => {
  let isOtherCompleted = true;
  const selectedPrinciples = Object.keys(principles).filter((principle) => {
    const { checked } = principles[principle];
    return checked;
  });

  const isRemarkEnValid =
    !remark?.descriptionEn ||
    (checkMessageEn(remark?.descriptionEn) &&
      validateSpaceTextInput(remark?.descriptionEn));

  selectedPrinciples.map((principle) => {
    const { infoCategoryMasterDataId, nameEn } = principles[principle];
    if (infoCategoryMasterDataId === GREENHOUSE_STANDARD_LIST_ID.OTHER) {
      if (nameEn && nameEn.trim() !== '' && checkMessageEn(nameEn)) {
        isOtherCompleted = true;
      } else {
        isOtherCompleted = false;
      }
    }
  });

  return selectedPrinciples.length > 0 && isOtherCompleted && isRemarkEnValid;
};

export const checkEmptyPrinciple = (
  principles: IEsgGreenhousePrincipleFormValues[]
) => {
  return principles.every(
    (principle) =>
      principle.checked === false || principle.checked === undefined
  );
};

export const checkAtLeastOnePrinciple = (
  principles: IEsgGreenhousePrincipleFormValues[]
) => {
  const principleChecks = principles.filter(
    (principle) => principle.checked === true
  );

  return principleChecks.length === 1;
};
